var map = {
	"./pexels-laura-paredis-13517794.jpg": 189,
	"./pexels-laura-paredis-13517796.jpg": 487,
	"./pexels-phearak-chamrien-13507215.jpg": 265,
	"./pexels-skyler-ewing-13424600.jpg": 44,
	"./pexels-wallace-silva-10654421.jpg": 668,
	"./pexels-şeyma-d-13508900.jpg": 994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;